<template>
    <modal name="modal-feedback" :pivotY="0.2" :width="650" height="auto" >
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('modal-feedback')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Форма обратной связи
        </div>
        <div class="cd-modal-grid">
            <div class="cd-modal-grid-element">
                <input type="text" class="input-absolute" placeholder="Введите данные" autocomplete="off" v-model="extraInput">
                <div class="margin-10-0">
                    Ваше имя:
                </div>
                <input type="text" class="cd-modal-text-input" v-model="customerName" placeholder="Ваше имя *">
                <div class="form-alert-danger" v-show="showAlert === 'customerName'">
                    Обязательное поле!
                </div>
            </div>
            <div class="cd-modal-grid-element">
                <div class="margin-10-0">
                    Телефон:
                </div>
                <input type="text" class="cd-modal-text-input" v-model="customerPhone" placeholder="Контактный телефон *" v-mask="'+# (###) ### ## ##'" v-on:focus="addCountryCode">
                <div class="form-alert-danger" v-show="showAlert === 'customerPhone'">
                    Обязательное поле!
                </div>
                <div class="form-alert-danger" v-show="showAlert === 'customerPhoneFormat'">
                    Неверный формат номера!
                </div>
            </div>
        </div>
        <div class="cd-modal-block">
            <div class="cd-modal-grid-element margin-10-30">
                <div class="margin-10-0">
                    Комментарии:
                </div>
                <div>
                    <textarea class="cd-modal-text-input modal-textarea" v-model="customerComment" placeholder="Что Вас интересует? *"></textarea>
                </div>
            </div>
        </div>
        <div class="cd-modal-grid add-padding">
            <div>
                <div class="pretty p-default">
                    <input type="checkbox" v-model="IAgree"/>
                    <div class="state p-danger">
                        <label></label>
                    </div>
                </div>
            </div>
            <div>
                Я даю своё согласие на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006 года №152-Ф3 "О персональных данных" на условиях, определённых в
                <a class="red-text" style="text-decoration: none" href="https://www.grandline.ru/politika-zashity-i-obrabotki-personalnyh-dannyh/" target="_blank">
                    Согласии на обработку персональных данных
                </a>
            </div>
        </div>
        <div class="button-alert-grid margin-30">
            <div class="gl-square-btn btn-grey" v-on:click="submitSend">
                Отправить
            </div>
            <div class="form-alert-danger-agreement" v-show="showAlert === 'IAgree'">
                Подтвердите согласие на обработку персональных данных!
            </div>
        </div>
    </modal>
</template>

<script>
    import SVGModalClose from "../SVG/SVGModalClose";
    import {modalMethods} from "../common";
    export default {
        name: "ModalFeedback",
        mixins: [modalMethods],
        components: {SVGModalClose},
        data() {
            return {
                IAgree: true,
                customerName: '',
                customerPhone: '',
                customerComment: '',
                showAlert: '',
                extraInput: ''
            }
        },
        methods: {
            addCountryCode() {
                if (this.customerPhone === '') {
                    this.customerPhone = 7
                }
            },
            feedbackValidation() {
                if (!this.customerName) {
                    this.showAlert = 'customerName'
                    return false
                } else if (!this.customerPhone) {
                    this.showAlert = 'customerPhone'
                    return false
                } else if (this.customerPhone.length !== 18) {
                    this.showAlert = 'customerPhoneFormat'
                    return false
                } else if (!this.IAgree) {
                    this.showAlert = 'IAgree'
                    return false
                } else {
                    return true
                }
            },
            async submitSend() {
                console.log(this.customerPhone.length)
                let validation = this.feedbackValidation()
                if (validation && !this.extraInput) {
                    await this.$store.dispatch('feedback/SEND_FEEDBACK_DATA', {
                        name: this.customerName,
                        phone: this.customerPhone,
                        comment: this.customerComment
                    });
                    this.hideModal("modal-feedback");
                }
            }
        }
    }
</script>

<style scoped>
    .margin-40 {
        margin: 40px;
    }

    .input-absolute {
        width: 0;
        height: 0;
        position: absolute;
        left: 999999px;
    }

    .cd-modal-block {
        margin: 20px 10px;
    }

    .margin-10-0 {
        margin: 10px 0;
    }

    .modal-textarea {
        resize: none;
        /*width: 910px;*/
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
    }
</style>
